import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { SELF_SERVE_SHOW_ALL_LANGUAGES_241003 } from "@faire/web-api/indigofair/settings/SELF_SERVE_SHOW_ALL_LANGUAGES_241003";
export function getSettingSelfServeShowAllLanguage() {
  return getSettingValueWithoutAssignment(SELF_SERVE_SHOW_ALL_LANGUAGES_241003, false);
}